<template>
  <section id="hero">
    <div id="gymCarousel" class="carousel slide" data-bs-ride="carousel">
      <div class="carousel-inner">
        <div
          class="carousel-item"
          v-for="(slide, i) in slides"
          :key="i"
          :class="{ active: i === 0 }"
        >
          <img :src="slide.img" class="d-block w-100 carousel-img" :alt="slide.title" />

          <!-- Overlay con animaciones -->
          <div class="carousel-caption d-flex flex-column justify-content-center align-items-center text-center">
            <!-- Título animado -->
            <h1 class="display-4 fw-bold hero-title welcome-animate delay-1">
              {{ slide.title }}
            </h1>

            <!-- Descripción con typing effect -->
            <p class="lead hero-subtitle typing-text delay-2">
              {{ typedText[i] }}
            </p>

            <!-- Botón animado -->
            <RouterLink
              to="/PlanesView"
              class="btn btn-lg fw-bold px-4 rounded-pill mt-3 hero-btn animate-pulse delay-3"
            >
              Ver Promociones
            </RouterLink>

            <!-- Partículas sutiles -->
            <div class="particle" v-for="n in 15" :key="n"></div>
          </div>
        </div>
      </div>

      <!-- Controles -->
      <button class="carousel-control-prev" type="button" data-bs-target="#gymCarousel" data-bs-slide="prev">
        <span class="carousel-control-prev-icon"></span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#gymCarousel" data-bs-slide="next">
        <span class="carousel-control-next-icon"></span>
      </button>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from "vue"

const slides = [
  {
    img: require("../assets/images/carruzel/gym1.webp"),
    title: "🎉 ¡Bienvenido a Victoria Fitness Center! 💪",
    desc: "Aquí no solo entrenas tu cuerpo, entrenas tu mentalidad de victoria. Desde el momento en que cruzas nuestras puertas, te conviertes en parte de una comunidad que cree en el esfuerzo, la disciplina y el poder de superarse cada día. 🏋️‍♂️✨"
  },
  {
    img: require("../assets/images/carruzel/gym2.webp"),
    title: "🔥 Transforma tu cuerpo",
    desc: "Entrena con los mejores instructores certificados y alcanza tus metas más rápido. Descubre programas diseñados para fuerza, resistencia y bienestar total. 💪🏽"
  },
  {
    img: require("../assets/images/carruzel/gym3.webp"),
    title: "🏋️ Tu salud, tu prioridad",
    desc: "Planes personalizados según tus objetivos, horarios flexibles y un ambiente motivador para que siempre superes tus límites. 💫"
  }
]

// Typing effect por slide
const typedText = ref(slides.map(() => ""))

function typeEffect(text, index) {
  let i = 0
  typedText.value[index] = ""
  const interval = setInterval(() => {
    typedText.value[index] += text.charAt(i)
    i++
    if (i >= text.length) clearInterval(interval)
  }, 40)
}

onMounted(() => {
  typeEffect(slides[0].desc, 0)
  const carousel = document.getElementById("gymCarousel")
  carousel.addEventListener("slid.bs.carousel", (event) => {
    const index = event.to
    typeEffect(slides[index].desc, index)
  })
})
</script>

<style scoped>
/* Fullscreen carousel */
.carousel, .carousel-item, .carousel-img { height: 100vh; }

/* Imagen con zoom suave */
.carousel-img {
  object-fit: cover;
  filter: brightness(0.5);
  transition: transform 12s ease-in-out;
}
.carousel-item.active .carousel-img {
  transform: scale(1.08) translateY(-10px);
}

/* Overlay full-screen */
.carousel-caption {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.35);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 2rem;
  text-align: center;
}

/* Animaciones de bienvenida */
@keyframes fadeSlideZoom {
  0% { opacity: 0; transform: translateY(50px) scale(0.9);}
  50% { opacity: 0.7; transform: translateY(20px) scale(1.05);}
  100% { opacity: 1; transform: translateY(0) scale(1);}
}
.welcome-animate { animation: fadeSlideZoom 1.2s ease-out forwards; }
.delay-1 { animation-delay: 0.3s; }
.delay-2 { animation-delay: 1.2s; }
.delay-3 { animation-delay: 2.2s; }

/* Subtitulo typing más grueso */
.hero-subtitle {
  color: #F97316;
  text-shadow: 1px 1px 6px rgba(0,0,0,0.7);
  font-weight: 700; /* más grueso */
  max-width: 800px;
  min-height: 3rem;
  margin-top: 1rem;
  line-height: 1.5;
}
.typing-text::after {
  content: "|";
  animation: blink 0.7s infinite;
  color: #F97316;
}
@keyframes blink { 50% { opacity: 0; } }

/* Botón animado */
.animate-pulse {
  animation: pulse 2s infinite ease-in-out;
  background-color: #F97316;
  color: white;
  font-weight: 700;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.animate-pulse:hover {
  transform: scale(1.1);
  box-shadow: 0px 0px 15px rgba(249, 115, 22, 0.7);
}
@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}

/* Partículas sutiles flotantes */
.particle {
  position: absolute;
  width: 6px; height: 6px;
  background: rgba(255,255,255,0.6);
  border-radius: 50%;
  top: calc(100% * var(--y, 0.5));
  left: calc(100% * var(--x, 0.5));
  animation: float 6s linear infinite;
}
@keyframes float {
  0% { transform: translateY(0) scale(1); opacity: 1;}
  50% { transform: translateY(-50px) scale(0.8); opacity: 0.6;}
  100% { transform: translateY(-100px) scale(1); opacity: 0;}
}

/* Responsivo */
@media (max-width: 768px) {
  .hero-title { font-size: 2rem; font-weight: 700; }
  .hero-subtitle { font-size: 1rem; font-weight: 700; max-width: 95%; }
  .btn { padding: 0.5rem 1rem; font-size: 0.9rem; font-weight: 700; }
}
</style>
